import gql from 'graphql-tag'

const specialProductExpenses = gql`
query getExpenseNames {
	cashAssist {
		getAppConfig {
			specialProductExpenses
		}
	}
}
`

export default specialProductExpenses
